import { Pagination } from "react-bootstrap";

const PaginationComponent = ({
  currentPage,
  setCurrentPage,
  totalData,
  onPageChange,
  limit,
  route,
}) => {
  const totalPages = Math.ceil(totalData / limit);

  const items = [];
  const activePage = currentPage + 1;
  const siblings = 2;

  // Function to create page items
  const createPaginationItems = () => {
    if (totalPages <= 7) {
      for (let number = 1; number <= totalPages; number++) {
        items.push(
          <Pagination.Item
            key={number}
            active={activePage === number}
            onClick={() => onPageChange(number)}
          >
            {number}
          </Pagination.Item>
        );
      }
    } else {
      let left = Math.max(1, activePage - siblings);
      let right = Math.min(totalPages, activePage + siblings);

      const showLeftEllipsis = left > 3;
      const showRightEllipsis = right < totalPages - 2;

      const pages = [];

      if (!showLeftEllipsis && showRightEllipsis) {
        const maxRight = Math.max(5, right);
        for (let i = 1; i <= maxRight; i++) {
          pages.push(i);
        }
        pages.push('ellipsis-right');
        pages.push(totalPages);
      } else if (showLeftEllipsis && !showRightEllipsis) {
        pages.push(1);
        pages.push('ellipsis-left');
        const minLeft = Math.min(totalPages - 4, left);
        for (let i = minLeft; i <= totalPages; i++) {
          pages.push(i);
        }
      } else if (showLeftEllipsis && showRightEllipsis) {
        pages.push(1);
        pages.push('ellipsis-left');
        for (let i = left; i <= right; i++) {
          pages.push(i);
        }
        pages.push('ellipsis-right');
        pages.push(totalPages);
      } else {
        for (let i = 1; i <= totalPages; i++) {
          pages.push(i);
        }
      }

      pages.forEach(number => {
        if (number === 'ellipsis-left') {
          items.push(
            <Pagination.Ellipsis 
              key="ellipsis-left" 
              onClick={() => onPageChange(Math.max(1, activePage - 5))} 
            />
          );
        } else if (number === 'ellipsis-right') {
          items.push(
            <Pagination.Ellipsis 
              key="ellipsis-right" 
              onClick={() => onPageChange(Math.min(totalPages, activePage + 5))} 
            />
          );
        } else {
          items.push(
            <Pagination.Item
              key={number}
              active={activePage === number}
              onClick={() => onPageChange(number)}
            >
              {number}
            </Pagination.Item>
          );
        }
      });
    }
  };

  createPaginationItems();

  return (
    <>
      {totalPages > 1 && (
        <Pagination>
          
          <Pagination.First
            disabled={currentPage === 0}
            onClick={() => onPageChange(1)}
          />

          
          <Pagination.Prev
            disabled={currentPage === 0}
            onClick={() => onPageChange(currentPage)}
          />

          
          {items}

          
          <Pagination.Next
            disabled={currentPage === totalPages - 1}
            onClick={() => onPageChange(currentPage + 2)}
          />

          
          <Pagination.Last
            disabled={currentPage === totalPages - 1}
            onClick={() => onPageChange(totalPages)}
          />
        </Pagination>
      )}
    </>
  );
};

export default PaginationComponent;
